import { useRef, useEffect, useState } from "react";
import { useInView } from "framer-motion";
import { FadeIn } from "./FadeIn";

const STATS = [
  { end: 275, suffix: "+", label: "Grand Events Organized" },
  { end: 1700, prefix: "1,500 – ", format: true, label: "Persons Total Guest Capacity" },
  { end: 230, suffix: "+", label: "Cars Parking Area Capacity" },
];

const Counter = ({ end, suffix = "", prefix = "", format }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 2000;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      setVal(Math.round(end * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, end]);

  return (
    <span ref={ref} className="font-serif-luxe text-6xl md:text-7xl font-medium text-[#D4AF37]">
      {prefix}{format ? val.toLocaleString("en-IN") : val}{suffix}
    </span>
  );
};

export const Counters = () => (
  <section data-testid="counters-section" className="bg-[#043927] py-24 lg:py-28 relative overflow-hidden">
    <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 20% 50%, #D4AF37 1px, transparent 1px)", backgroundSize: "36px 36px" }} />
    <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
      <FadeIn>
        <p className="text-center text-[#D4AF37] uppercase tracking-[0.4em] text-xs mb-16">The Grandeur in Numbers</p>
      </FadeIn>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-14 md:gap-8">
        {STATS.map((s, i) => (
          <FadeIn key={s.label} delay={i * 0.15} className="text-center">
            <Counter {...s} />
            <div className="h-px w-14 bg-[#D4AF37]/50 mx-auto my-5" />
            <p className="text-[#FAF9F6]/80 text-sm md:text-base tracking-wide uppercase">{s.label}</p>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);
